<template>
	<div class="container">
    <div class="survey-title mb40 has-text-centered">When using cannabis, how do you want to <span
        class="highlight-text">feel</span>?</div>
    <div class="fields-block mb60">
      <h3 class="title has-text-centered">Select as many as you like.</h3>
      <div class="columns justify-content-center">
        <div class="column is-12-mobile is-8-tablet is-7-desktop">
          <div class="field is-grouped is-flex-tablet is-flex-wrap justify-content-start">
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Alert" class="is-checkradio is-block" id="pref-feel-alert" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-alert"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Alert</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Creative" class="is-checkradio is-block" id="pref-feel-creative" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-creative"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Creative</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Energetic" class="is-checkradio is-block" id="pref-feel-energetic" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-energetic"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Energetic</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Eurphoric" class="is-checkradio is-block" id="pref-feel-eurphoric" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-eurphoric"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Eurphoric</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Focused"  class="is-checkradio is-block" id="pref-feel-focused" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-focused"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Focused</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Giggly" class="is-checkradio is-block" id="pref-feel-giggly" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-giggly"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Giggly</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Happy" class="is-checkradio is-block" id="pref-feel-happy" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-happy"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Happy</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Relaxed" class="is-checkradio is-block" id="pref-feel-relaxed" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-relaxed"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Relaxed</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Serene" class="is-checkradio is-block" id="pref-feel-serene" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-serene"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Serene</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Sleepy" class="is-checkradio is-block" id="pref-feel-sleepy" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-sleepy"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Sleepy</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Talkative" class="is-checkradio is-block" id="pref-feel-talkative" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-talkative"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Talkative</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Uplifted" class="is-checkradio is-block" id="pref-feel-uplifted" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-uplifted"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Uplifted</h4>
              </label>
            </div>
            <div class="control pref-block pref-feel-block mr5 ml5 mb10 has-text-centered">
              <input v-model="feel" value="Pain Relief" class="is-checkradio is-block" id="pref-feel-painrelief" type="checkbox"
                name="pref-feel">
              <label for="pref-feel-painrelief"
                class="is-flex is-flex-column align-items-center justify-content-center">
                <h4 class="pref-label">Pain Relief</h4>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps mt100 mb50">
      <ul class="is-flex justify-content-around">
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class="is-active"></li>
        <li class=""></li>
        <li class=""></li>
        <li class="mr0"></li>
      </ul>
    </div>
    <div class="next-button is-flex align-items-center justify-content-center has-text-centered mb50">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-mobile mr40 m0-xs">Back</a>
      <a href="#" @click.prevent="next()" class="button is-primary ml40 is-marginless-tablet">Next</a>
    </div>
    <div
      class="skip-button is-flex-mobile align-items-center justify-content-between has-text-centered mb30">
      <a href="#" @click.prevent="back()" class="back-btn is-primary is-hidden-tablet">Back</a>
      <a href="#" @click.prevent="setStep(5)" class="is-primary">Skip</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      feel: [],
    };
  },
  computed: {
    ...mapGetters({
      step: "usersurvey/step"
    })
  },
  methods: {
    /**
     * Step back
     */
    back() {
      this.setStep(2);
      this.setSurvey({
        type: [],
      })
    },

    /**
     * Next step 
     */
    next() {
      if(this.feel == '') {
        this.setSnackbar({
          modal: true,
          message: 'Please choose, how do you want to feel.',
          type: 'warning',
        }) 
      } else {
        this.setSurvey({
          feel: this.feel
        })
        this.setStep(5);
      }
    },
    ...mapActions({
      setSnackbar: "snackbar/setSnackbar",
      setStep: "usersurvey/setStep",
      setSurvey: "usersurvey/setSurvey"
    })
  },
};
</script>